import "./App.css";
import "./MemberAll.css";
import { BrowserRouter, Routes, Route, Router, Navigate } from "react-router-dom";
import Admin from "./components/admin/Admin";
import React from "react";
import Login from "./components/public/login/Login";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";
import PrivateAdminRoutes from "./components/public/PrivateAdminRoutes";




function App() {
  return (
    <>
      <BrowserRouter>
        <div className="member-main">
          <Routes>
            <Route path="/login" element={<Login />}/>
            <Route element={<PrivateAdminRoutes />}>
                <Route element={<Admin/>} path="/admin/*"/>
            </Route>
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </div>
      </BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
